<template>
    <div v-if="limit" class="text-gray text-sm absolute right-0 -top-[22px]">{{ char_counter }}/{{ limit }}</div>
    <textarea data-slot="control" v-model="modelValue" :rows="rows" :maxlength="limit" v-bind="$attrs" :aria-invalid="hasError" :aria-describedby="errorId" :placeholder="translatedPlaceholder"></textarea>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineOptions({
    inheritAttrs: false
})

const { t } = useI18n()

const modelValue = defineModel()
const props = defineProps({
    rows: {
        type: [Number, String],
        default: 10
    },
    limit: {
        type: [Number, String],
        default: 500
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorId: {
        type: String,
        default: null
    },
    placeholder: {
        type: String,
        default: ''
    }
})

const char_counter = computed(() => modelValue.value?.length)
const translatedPlaceholder = computed(() => {
    return props.placeholder ? t(props.placeholder) : ''
})
</script>
